// extracted by mini-css-extract-plugin
export default {"accordion":"AccordionCard_accordion__8wsDq","accordionHeader":"AccordionCard_accordionHeader__AleHd","accordionItem":"AccordionCard_accordionItem__KdI-2"};